import { useTranslation } from "react-i18next";
import AccessibleContent from '../../../utils/AccessibleContent';

const TopSection = ({ step, store, lang, selectedStore }) => {
  const { t } = useTranslation();

  const isMeaningfulHtml = (html) => {
    if (!html) return false;
      let text = html.replace(/<[^>]*>/g, '');
      text = text.replace(/&nbsp;/gi, ' ');
      text = text.replace(/\s+/g, ' ').trim();
    return text.length > 0;
  };
  
  const getHeadContent = () => {
    if (store.discount?.teaser) {
      const discountTeaser = store.discount.teaser[lang] || '';
      return isMeaningfulHtml(discountTeaser) ? discountTeaser : '';
    }
  
    if (selectedStore === 'digital') {
      const accroche = store.texteAccroche?.[lang] || '';
      const html = accroche
        ? accroche.replace("<p>", "<h2>").replace("</p>", "</h2>")
        : '';
      return isMeaningfulHtml(html) ? html : '';
    }
  
    const physical = store.physical_store?.texts?.card_list_teaser?.[lang] || '';
    return isMeaningfulHtml(physical) ? physical : '';
  };
  const headContent = getHeadContent();
  const showHeadBlock = isMeaningfulHtml(headContent);
  const goTo = (path, preserveParams = true) => {
    const currentPath = window.location.pathname;
    const currentParams = window.location.search;
    let finalPath = path;

    if (path === '/home') {
      const homeSubPath = currentPath.match(/^\/home(\/\w+)?/);
      if (homeSubPath && homeSubPath[1]) {
        finalPath = `/home${homeSubPath[1]}`;
      }
    }

    if (preserveParams && currentParams) {
      const separator = finalPath.includes('?') ? '&' : '?';
      finalPath = `${finalPath}${separator}${currentParams.substring(1)}`;
    }

    window.location.href = finalPath;
  };

  return (
    <div id="topSection" role="region" aria-label={t("Information de l'enseigne")}>
      <div className={`overlayBox ${store.mainImageFilter ? 'overlay' : ''}`}>
      {step === 1 && (
  <div className="wrapper">
    {showHeadBlock && (
      <>
        <AccessibleContent
          className="headContent accrocheColor"
          htmlContent={headContent}
        />

        {!store.exception && (
          <div className="showMoreBox">
            <a
              href="/detail"
              onClick={(e) => { e.preventDefault(); goTo('/detail'); }}
              translate="no"
              aria-label={t('En savoir plus')}
            >
              {t("En savoir plus")}
            </a>
          </div>
        )}
      </>
    )}
  </div>
)}
        {step === 2 && (
          <div className="wrapper">
            <div className="headContent">{t("Vérifiez votre achat et renseignez vos coordonnées")}</div>
          </div>
        )}
        {step === 3 && (
          <div className="wrapper">
            <div className="headContent">
              {t("Votre commande a été enregistrée avec succès ! Gardez précieusement ces informations.")}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
export default TopSection;